class TipoDestinacaoService extends EficienciaFiscalAbstractService

  configure: (configs, injector) ->
    configs.url = '/icms/tipo-destinacao'
    configs.wrappedIn = 'tipo_destinacao'

    super(configs, injector)

angular.module('eficienciaFiscalModule').service('tipoDestinacaoService', TipoDestinacaoService)
